<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="attendees.length > 0">
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomerattendees.first-name' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomerattendees.last-name' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomerattendees.company' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomerattendees.job-function' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomerattendees.phone' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomerattendees.email' | translate }}</strong>
      </span>
    </td>
  </tr>
  <tr *ngFor="let attendee of attendees">
    <td>
      <span>{{ attendee.FirstName }}</span>
    </td>
    <td>
      <span>{{ attendee.LastName }}</span>
    </td>
    <td>
      <span>{{ attendee.Company }}</span>
    </td>
    <td>
      <span>{{ attendee.JobFunction }}</span>
    </td>
    <td>
      <span>{{ attendee.Phone }}</span>
    </td>
    <td>
      <span>{{ attendee.Email }}</span>
    </td>
  </tr>
</table>
